import Video from './video-block-view';

export default Video;
